var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToneFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161 -652)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    transform: "translate(161 652)",
    fill: "#cc1d91"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166 657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1,10.052A7.052,7.052,0,1,1,10.052,3,7.052,7.052,0,0,1,17.1,10.052Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,21a3.808,3.808,0,0,0,2.821,1.41A3.808,3.808,0,0,0,17.642,21",
    transform: "translate(-4.769 -9.537)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.5h.007",
    transform: "translate(-5.563 -5.563)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,13.5h.007",
    transform: "translate(-10.332 -5.563)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToneFriend);
export default __webpack_public_path__ + "static/media/tone_friend.e3dcf8941a94f8dd5e3768233d41855b.svg";
export { ForwardRef as ReactComponent };